module.exports = __webpack_public_path__ + "img/support_illustration.6ea29b70.svg";